import {combineReducers} from "redux";
import user from "./redux/user/reducer";
import report from "./redux/report/reducer";
import alert from "./redux/alert/reducer";
import modal from "./redux/modal/reducer";
import layout from "./redux/layout/reducer";

const rootReducer = (state, action) => {
    switch (action.type) {
        default: {
            const combinedReducer = combineReducers({
                user,
                report,
                alert,
                modal,
                layout,
            });
            return combinedReducer(state, action);
        }
    }
};

export default rootReducer;
